import { JSX, useContext } from "react";
import { NewActionMenu, NewActionMenuItem } from "@app/shared/action-menu";
import { NetworkIntegrityFilterContext, NetworkIntegrityProviderTypes } from '.';
import { NetworkIntegrityFilterAction } from './networkIntegrityFilterStateManagement';

const NetworkIntegrityProviderTypeFilter = (): JSX.Element => {
  const context = useContext(NetworkIntegrityFilterContext);

  const handleProviderTypeChange = (value: string): void => {
    if (value !== context.providerType) {
      context.providerTypeChanged({ type: NetworkIntegrityFilterAction.ProviderTypeFilterChanged, value });
    }
  }

  const getProviderTypeList = (): string[] => {
    const providerTypeList: string[] = [];

    for (const t of Object.values(NetworkIntegrityProviderTypes)) {
        providerTypeList.push(t);
      }

    return providerTypeList;
  }

  return (
    <NewActionMenu
      buttonText={`View: ${context.providerType} Providers`}
      buttonClassNames="qes-button-secondary"
      testId="netword-integrity-filters__provider-type"
      key="netword-integrity-filters__provider-type"
    >
      {getProviderTypeList().map((t) => {
        return (
          <NewActionMenuItem
            display={t}
            isSelected={context.providerType == t}
            key={`netword-integrity-filters__provider-type-option--${t}`}
            onClick={() => handleProviderTypeChange(t)}
            testId={`netword-integrity-filters__provider-type-option--${t}`}
          />
        );
      })}
    </NewActionMenu>
  );
};

export default NetworkIntegrityProviderTypeFilter;